import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'
import { ServiceHeaderModel } from '../../../types/services/serviceModel'
import { ClassValue } from 'classnames/types'
import parse from 'html-react-parser'

const useStyle = makeStyles((theme) => {
	return {
		...styles(theme),
		servicesHeaderStyle: {
			position: 'relative',
			backgroundSize: 'cover',
			backgroundPositionX: 'right',

			'& img': {
				width: '100%'
			},

			'& #header_text': {
				position: 'absolute',
				top: '25%',
				left: 40,
				color: 'white',
				width: '80%'
			}
		},
		servicesHeaderImageLargeScreenStyle: {
			height: 350
		},
		servicesHeaderImageSmallScreenStyle: {
			height: 415
		},
		servicesSubTitle: {
			color: theme.palette.blue.main,
			marginTop: 50,
			marginBottom: 50,
			'& p, & h1, & h2, & h3, & h4, & ul, & ol': {
				margin: 0
			}
		}
	}
})

interface AcceptingProps {
	header: ServiceHeaderModel
}

type HeaderProps = AcceptingProps

const ServicesPageHeader: React.FC<HeaderProps> = (
	{
		header
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const servicesHeaderClass: ClassValue = classNames(
		isLargeScreen ? classes.servicesHeaderImageLargeScreenStyle : classes.servicesHeaderImageSmallScreenStyle,
		classes.servicesHeaderStyle
	)
	const titleClass: ClassValue = classNames(
		isLargeScreen ? classes.title0 : classes.title2
	)

	const subTitleClass: ClassValue = classNames(
		isLargeScreen ? classes.text0 : classes.text1
	)

	return (
		<>
			<div className={servicesHeaderClass} style={{ backgroundImage: `url(${header.picture})` }}>
                <span
	                className={titleClass}
	                id="header_text"
                >
                    {header.title}
                </span>
			</div>
			<div className={classes.servicesSubTitle}>
				<span className={subTitleClass}>{parse(header.content)}</span>
			</div>
		</>
	)
}

export default ServicesPageHeader
